import { ListPayload } from 'core/http/response';

/**
 * The listed products that have errors, as one page - the filter runs over every listed item, so
 * the pagination has nothing more to page through.
 *
 * Generic over the whole payload, so a caller holding a union of payload types gets the same union back.
 */
const filterProductsWithErrors = <TPayload extends ListPayload<{ id?: string }>>(
    products: TPayload,
    itemIdsWithErrors: Set<string>
): TPayload => {
    const productsWithErrors = products.list.filter(({ id }) => !!id && itemIdsWithErrors.has(id));

    return { ...products, list: productsWithErrors, total: productsWithErrors.length, pageNumber: 0 };
};

export default filterProductsWithErrors;
